import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { color } from '../globalStyles'

export default ({ source, className = '' }) => (
  <Content
    className={`Content ${className}`}
    source={source}
    escapeHtml={false}
    renderers={{
      link: LinkRenderer
    }}
  />
)

const LinkRenderer = ({ href, children, ...props }) =>
  href.indexOf('http') === 0 ? (
    <a href={href} {...props}>
      {children}
    </a>
  ) : (
    <ContentLink to={href} {...props}>
      {children}
    </ContentLink>
  )

const Content = styled(ReactMarkdown)`
  line-height: 1.4;
  font-weight: 400;
  overflow: hidden;

  .img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 2rem auto;
  }

  &:last-child > *:last-child {
    margin-bottom: 0;
  }
`

const ContentLink = styled(Link)`
  text-decoration: none;
  border-bottom: 1px dotted ${color.darkGrey};

  &:hover,
  &:focus {
    border-bottom-style: solid;
  }
`



// WEBPACK FOOTER //
// ./src/components/Content.js